import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import {
  ApolloClient,
  InMemoryCache,
  ApolloProvider,
  split,
  HttpLink,
} from "@apollo/client";
import { getMainDefinition } from "@apollo/client/utilities";
import { WebSocketLink } from "@apollo/client/link/ws";
import { setContext } from "@apollo/client/link/context";
import { SubscriptionClient } from "subscriptions-transport-ws";

import HomePage from "./components/Pages/HomePage";
import LoginOwnerPage from "./components/Pages/LoginOwnerPage";
import ResetPasswordPage from "./components/Pages/ResetPasswordPage";
import CreateOwnerPage from "./components/Pages/CreateOwnerPage";
import MyAccountPage from "./components/Pages/MyAccountPage";
import UpdateAccountPage from "./components/Pages/UpdateAccountPage.js";
import QRCodePage from "./components/Pages/QRCodePage.js";
import MLPage from "./components/Pages/MLPage.js";
import AppDataPrivacy from "./components/Pages/AppDataPrivacy";
import CGUPage from "./components/Pages/CGUPage";
import NotFoundPage from "./components/Pages/404";
import "./App.scss";

console.log("Carte Verte V1.7");

const httpLink = new HttpLink({
  uri:
    window.location.hostname === "localhost"
      ? "http://localhost:4000/"
      : "https://api.carteverte.co",
  credentials: "include",
});

let cvsubtok = document.cookie.split(";").find((cookie) => {
  return cookie.includes("cvsubtok");
});
if (cvsubtok) cvsubtok = cvsubtok.replace("cvsubtok=", "").trim();

let addressIdxCookie = document.cookie.split(";").find((cookie) => {
  return cookie.includes("addressIdx");
});
if (addressIdxCookie)
  addressIdxCookie = addressIdxCookie.split("addressIdx=")[1];

const wss =
  window.location.hostname === "localhost"
    ? "ws://localhost:4000/"
    : "wss://api.carteverte.co";
const wsClient = new SubscriptionClient(`${wss}`, {
  path: "/mon-compte/qrcode",
  reconnect: true,
  lazy: false,
  connectionParams: () => ({
    Authorization: "cvsubtok=" + cvsubtok || "",
    AddressIdx: addressIdxCookie || "",
  }),
  connectionCallback: (error) => {
    if (error) console.log("wss error", error);
  },
});
const wsLink = new WebSocketLink(wsClient);

const splitLink = split(
  ({ query }) => {
    const definition = getMainDefinition(query);
    return (
      definition.kind === "OperationDefinition" &&
      definition.operation === "subscription"
    );
  },
  wsLink,
  httpLink
);

const authLink = setContext((_, { headers }) => ({
  credentials: "include",
  headers: {
    ...headers,
    credentials: "include",
  },
}));

const client = new ApolloClient({
  link: authLink.concat(splitLink),
  cache: new InMemoryCache(),
  credentials: "include",
});



const root = createRoot(document.getElementById("root"));
root.render(
  <ApolloProvider client={client}>
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/login" element={<LoginOwnerPage />} />
        <Route path="/mot-de-passe-oublie" element={<ResetPasswordPage />} />
        <Route path="/signup" element={<CreateOwnerPage />} />
        <Route path="/mon-compte" element={<MyAccountPage />} />
        <Route path="/mon-compte/modifier" element={<UpdateAccountPage />} />
        <Route path="/mon-compte/qrcode" element={<QRCodePage />} />
        <Route path="/mentions-legales" element={<MLPage />} />
        <Route path="/app-data-privacy" element={<AppDataPrivacy />} />
        <Route path="/cgu" element={<CGUPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </Router>
  </ApolloProvider>
);

export { client };